import { ConnectionPositionPair } from '@angular/cdk/overlay';

export class PopupTooltipConfig
{
    /**
     *
     * @param height hauteur de la tooltip en px
     * @param width largeur de la tooltip en vw
     * @param positions collection de positions de la tooltip par rapport à son parent
     */
    constructor (public width: number = 0, public height: number = 0, public positions: ConnectionPositionPair[] = [])
    {
    }
}
